module.exports = __webpack_public_path__ + "img/horizontal_3_5_8011.bed294c0.png";